import { render, staticRenderFns } from "./SelfSignUpCampana.vue?vue&type=template&id=126f9a78&scoped=true&lang=pug"
import script from "./SelfSignUpCampana.vue?vue&type=script&lang=js"
export * from "./SelfSignUpCampana.vue?vue&type=script&lang=js"
import style0 from "./SelfSignUpCampana.vue?vue&type=style&index=0&id=126f9a78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126f9a78",
  null
  
)

export default component.exports